import { httpClient } from '@/core/api/httpClient';
import { mockTasks, mockTimeEntries } from './calendar.mock';

interface RawTaskEvent {
  id: string;
  title: string;
  dueDate: string;
  startDate?: string;
}

interface RawTimeEntryEvent {
  id: string;
  description: string;
  startedAt: string;
  durationSeconds: number;
}

interface CalendarRangeParams {
  startDate: string;
  endDate: string;
}

import { env } from '@/core/config/env';

const USE_MOCK = env.VITE_USE_MOCK === 'true';

/**
 * Org-scoped legacy calendar endpoints (`/organizations/{id}/calendar/*`) do
 * NOT exist in any backend (spec §6 — backend phase pending). Against a real
 * API they 404 and black out the whole view, so the sources that depend on
 * them are gated: they only run in mock mode. Flip/remove once the backend
 * ships `GET /api/calendar/tasks` and `GET /api/calendar/time-entries`.
 */
export const CALENDAR_LEGACY_API_AVAILABLE = USE_MOCK;

export const calendarService = {
  // TODO: Endpoints pending backend spec — routes below are not defined in api.json
  getTasks: async (
    orgId: string,
    params: CalendarRangeParams,
    signal?: AbortSignal,
  ): Promise<RawTaskEvent[]> => {
    if (USE_MOCK) {
      return mockTasks.filter((t) => t.dueDate >= params.startDate && t.dueDate <= params.endDate);
    }

    const { data } = await httpClient.get<RawTaskEvent[]>(
      `/organizations/${orgId}/calendar/tasks`,
      { params, signal },
    );
    return data;
  },

  getTimeEntries: async (
    orgId: string,
    params: CalendarRangeParams,
    signal?: AbortSignal,
  ): Promise<RawTimeEntryEvent[]> => {
    if (USE_MOCK) {
      const startDate = params.startDate;
      const endDate = params.endDate;
      return mockTimeEntries.filter((te) => {
        const entryDate = te.startedAt.slice(0, 10);
        return entryDate >= startDate && entryDate <= endDate;
      });
    }

    const { data } = await httpClient.get<RawTimeEntryEvent[]>(
      `/organizations/${orgId}/calendar/time-entries`,
      { params, signal },
    );
    return data;
  },
};
